import { SortSegmentEndpoints } from "./types";

/**
 * Normalizes segment endpoints by sorting IDs alphabetically.
 * This treats path A->B and B->A as the same undirected segment.
 */
export const sortSegmentEndpoints: SortSegmentEndpoints = ({
  pointAId,
  pointBId,
}) => {
  const [first, second] = [pointAId, pointBId].sort();
  return { from: first, to: second };
};
